import { Component } from "react";

import { withTranslation } from "react-i18next";

import { Grid, Icon } from "semantic-ui-react";
import { useTheme } from "styled-components";

import { GiphyGif } from "simplydo/react/components/Giphy/Gif";

import FormattedComment from "components/lib/FormattedComment";

import FeedCard from "./FeedCard";

const CardLeft = ({ comment }) => {
  const hasComment = !!comment.comment;
  const hasMedia = comment.media?.length;
  const firstMediaItem = hasMedia ? comment.media[0] : {};
  const firstMediaItemIsImage =
    firstMediaItem.type === "gif" || firstMediaItem.type === "image";
  const firstMediaIsGif = firstMediaItem.type === "gif";
  const theme = useTheme();
  return (
    <Grid.Column
      stretched
      width={12}
      verticalAlign="middle"
      className="comment-column"
    >
      <div className="comment-column-container">
        <Icon
          style={{
            color: theme.primaryColour,
            marginRight: 15,
            fontSize: "3em",
          }}
          name="comment alternate"
          size="big"
        />
        {!hasComment && hasMedia && firstMediaItemIsImage ?
          firstMediaIsGif ?
            <GiphyGif gif={firstMediaItem.data} size="fixed" />
          : <img
              style={{ borderRadius: 5, objectFit: "contain", maxHeight: 150 }}
              alt={firstMediaItemIsImage.value}
              src={firstMediaItem.signedDownloadRequest || firstMediaItem.value}
            />

        : null}
        {hasComment ?
          <p style={{ maxHeight: "100%", color: "#5d5d5d" }}>
            <FormattedComment noLink>"{comment.comment}"</FormattedComment>
          </p>
        : null}
      </div>
    </Grid.Column>
  );
};

class ChallengeIdeaCommentCard extends Component {
  render() {
    const { comment, hideAction, feedType, setIdeaPreviewId } = this.props;
    return (
      <FeedCard
        user={comment.owner}
        action={"activityFeed.challengeComment.action"}
        feedType={feedType}
        subjectItem={comment.idea.name}
        subjectItem2={comment.ownerChallenge?.name}
        date={comment.createdAt}
        type="COMMENT"
        cardLeft={<CardLeft comment={comment} />}
        hideAction={hideAction}
        setIdeaPreviewId={setIdeaPreviewId}
        ideaId={comment.idea._id}
        commentId={comment._id}
      />
    );
  }
}

export default withTranslation()(ChallengeIdeaCommentCard);
